(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[356],{

/***/ 83233:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(27378);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(23615);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(60042);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _shared_components_Tabs_TabBar__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(78329);
/* harmony import */ var _shared_utils_select__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(48018);
/* harmony import */ var _Tabs_module_scss__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(90042);
/* harmony import */ var _Tabs_module_scss__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_Tabs_module_scss__WEBPACK_IMPORTED_MODULE_5__);







var Tabs = function Tabs(_ref) {
  var tabVariant = _ref.tabVariant,
      tabs = _ref.tabs,
      value = _ref.value,
      _ref$className = _ref.className,
      className = _ref$className === void 0 ? "" : _ref$className,
      activeTabClassName = _ref.activeTabClassName,
      _ref$innerClassName = _ref.innerClassName,
      innerClassName = _ref$innerClassName === void 0 ? "" : _ref$innerClassName,
      _ref$tabClassName = _ref.tabClassName,
      tabClassName = _ref$tabClassName === void 0 ? "" : _ref$tabClassName,
      onChangeTab = _ref.onChangeTab,
      children = _ref.children;

  if (!tabs) {
    return null;
  }

  var indexActive = tabs.findIndex(function (t) {
    return (0,_shared_utils_select__WEBPACK_IMPORTED_MODULE_4__/* .getOptionKey */ ._)(t) === value;
  });
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
    className: classnames__WEBPACK_IMPORTED_MODULE_2___default()((_Tabs_module_scss__WEBPACK_IMPORTED_MODULE_5___default()["base-tabs"]), className)
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_shared_components_Tabs_TabBar__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
    tabVariant: tabVariant,
    className: innerClassName,
    tabClassName: tabClassName,
    activeTabClassName: activeTabClassName,
    current: value,
    options: tabs,
    onSelectTab: onChangeTab
  }), children && children.map(function (child, index) {
    return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
      key: index,
      "data-id": index,
      role: "tabpanel",
      className: classnames__WEBPACK_IMPORTED_MODULE_2___default()((_Tabs_module_scss__WEBPACK_IMPORTED_MODULE_5___default()["base-tabs__body"]), tabClassName),
      style: index === indexActive ? null : {
        display: "none"
      }
    }, child);
  }));
};

Tabs.propTypes = {
  tabs: (prop_types__WEBPACK_IMPORTED_MODULE_1___default().array),
  activeIndex: (prop_types__WEBPACK_IMPORTED_MODULE_1___default().any),
  className: (prop_types__WEBPACK_IMPORTED_MODULE_1___default().string),
  activeTabClassName: (prop_types__WEBPACK_IMPORTED_MODULE_1___default().string),
  innerClassName: (prop_types__WEBPACK_IMPORTED_MODULE_1___default().string),
  tabClassName: (prop_types__WEBPACK_IMPORTED_MODULE_1___default().string),
  setActiveTabIndex: (prop_types__WEBPACK_IMPORTED_MODULE_1___default().func),
  children: (prop_types__WEBPACK_IMPORTED_MODULE_1___default().node)
};
/* harmony default export */ __webpack_exports__["Z"] = (Tabs);

/***/ }),

/***/ 5522:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ _subscription_; }
});

// EXTERNAL MODULE: ../node_modules/react/index.js
var react = __webpack_require__(27378);
// EXTERNAL MODULE: ./src/next/components/index.js + 9 modules
var components = __webpack_require__(78239);
// EXTERNAL MODULE: ../node_modules/next/router.js
var next_router = __webpack_require__(86677);
// EXTERNAL MODULE: ./src/next/components/Tabs/Tabs.js
var Tabs = __webpack_require__(83233);
// EXTERNAL MODULE: ../node_modules/next-i18next/dist/esm/index.js + 22 modules
var esm = __webpack_require__(60098);
// EXTERNAL MODULE: ../node_modules/prop-types/index.js
var prop_types = __webpack_require__(23615);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./src/next/contexts/subscriptions.js + 1 modules
var contexts_subscriptions = __webpack_require__(36895);
// EXTERNAL MODULE: ../node_modules/classnames/index.js
var classnames = __webpack_require__(60042);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./src/next/components/Button/LinkButton.js
var LinkButton = __webpack_require__(30508);
// EXTERNAL MODULE: ../shared/components/Button/Button.js
var Button = __webpack_require__(18170);
// EXTERNAL MODULE: ./src/next/components/SharePopup/SharePopup.js + 1 modules
var SharePopup = __webpack_require__(75702);
// EXTERNAL MODULE: ../shared/contexts/modal.js
var modal = __webpack_require__(26933);
// EXTERNAL MODULE: ./src/assets/CommonIcons.js
var CommonIcons = __webpack_require__(64666);
// EXTERNAL MODULE: ./src/next/utils/routes/routes.js
var routes = __webpack_require__(69994);
// EXTERNAL MODULE: ../shared/utils/subscriptions.js
var subscriptions = __webpack_require__(8816);
// EXTERNAL MODULE: ./src/next/components/subscriptions/Subscriptions.utils.js
var Subscriptions_utils = __webpack_require__(58753);
// EXTERNAL MODULE: ../shared/components/IconView/IconView.js
var IconView = __webpack_require__(20844);
// EXTERNAL MODULE: ./src/assets/EgwWebFont.js
var EgwWebFont = __webpack_require__(37462);
// EXTERNAL MODULE: ../node_modules/next/dynamic.js
var dynamic = __webpack_require__(65218);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./src/next/components/subscriptions/subscriptions.module.scss
var subscriptions_module = __webpack_require__(90843);
var subscriptions_module_default = /*#__PURE__*/__webpack_require__.n(subscriptions_module);
;// CONCATENATED MODULE: ./src/next/components/subscriptions/SubsItem.js
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }



















var BookCover = dynamic_default()(function () {
  return __webpack_require__.e(/* import() */ 657).then(__webpack_require__.bind(__webpack_require__, 33657));
}, {
  ssr: false
});

var SubsItem = function SubsItem(_ref) {
  var item = _ref.item,
      width = _ref.width,
      index = _ref.index;

  var _useTranslation = (0,esm/* useTranslation */.$G)(),
      t = _useTranslation.t;

  var router = (0,next_router.useRouter)();

  var _useSubscriptionsCont = (0,contexts_subscriptions/* useSubscriptionsContext */.T)(),
      date = _useSubscriptionsCont.date,
      unsubscribe = _useSubscriptionsCont.unsubscribe;

  var _useModalContext = (0,modal/* useModalContext */.v)(),
      showDialog = _useModalContext.showDialog;

  var _useState = (0,react.useState)(item.content.join("")),
      _useState2 = _slicedToArray(_useState, 2),
      content = _useState2[0],
      setContent = _useState2[1];

  (0,react.useEffect)(function () {
    if (!width) {
      return;
    }

    setContent((0,subscriptions/* cropHtmlContent */.T1)(width, item.content, false));
  }, [width]);

  var onOpenHandler = function onOpenHandler() {
    router.push((0,subscriptions/* makeSubsReadUrl */.z)(date, item.book_id));
  };

  var onSubscribeHandler = function onSubscribeHandler() {
    showDialog(t("deleteSub"), t("deleteSubWarn", {
      title: item.book_title
    }), function () {
      unsubscribe(item.subscription);
    }, {
      className: (subscriptions_module_default())["delete-sub-container"]
    });
  };

  var shareData = (0,Subscriptions_utils/* getShareData */.X)(item);
  return /*#__PURE__*/react.createElement("div", {
    key: index,
    className: (subscriptions_module_default())["subs-item"]
  }, /*#__PURE__*/react.createElement("div", {
    className: (subscriptions_module_default())["subs-item-img-container"]
  }, /*#__PURE__*/react.createElement("div", {
    className: (subscriptions_module_default())["subs-item-img"],
    onClick: onOpenHandler
  }, /*#__PURE__*/react.createElement("div", {
    className: (subscriptions_module_default())["subs-item-tap"]
  }, /*#__PURE__*/react.createElement("span", {
    className: (subscriptions_module_default())["subs-item-tap-text"]
  }, t("read")), /*#__PURE__*/react.createElement(CommonIcons/* BookCircle */.eZ, null)), /*#__PURE__*/react.createElement(BookCover, {
    book: item
  })), /*#__PURE__*/react.createElement("div", {
    className: (subscriptions_module_default())["subs-item-actions"]
  }, /*#__PURE__*/react.createElement(SharePopup/* default */.Z, _extends({}, shareData, {
    renderButton: function renderButton(_ref2) {
      var show = _ref2.show,
          onClick = _ref2.onClick;
      return /*#__PURE__*/react.createElement(Button/* default */.Z, {
        className: (subscriptions_module_default())["subs-item-action"],
        title: t("share"),
        active: show,
        onClick: onClick
      }, /*#__PURE__*/react.createElement(IconView/* default */.Z, {
        icon: EgwWebFont/* default.share */.Z.share,
        className: (subscriptions_module_default())["subs-item-action-icon"]
      }));
    }
  })), /*#__PURE__*/react.createElement(Button/* default */.Z, {
    className: (subscriptions_module_default())["subs-item-action"],
    title: item.subscription ? t("subscribed") : t("subscribe"),
    onClick: onSubscribeHandler
  }, /*#__PURE__*/react.createElement(IconView/* default */.Z, {
    icon: EgwWebFont/* default.subscription-outline */.Z["subscription-outline"],
    className: classnames_default()((subscriptions_module_default())["subs-item-action-icon"], (subscriptions_module_default())["subs-item-action-icon-selected"])
  })), /*#__PURE__*/react.createElement(LinkButton/* default */.Z, {
    href: (0,routes/* makeChapterUrl */.ME)(item.start_para_id),
    className: (subscriptions_module_default())["subs-item-action"],
    title: t("read")
  }, /*#__PURE__*/react.createElement(IconView/* default */.Z, {
    icon: EgwWebFont/* default.read */.Z.read,
    className: (subscriptions_module_default())["subs-item-action-icon"]
  })))), /*#__PURE__*/react.createElement("div", {
    className: (subscriptions_module_default())["subs-item-description"],
    onClick: onOpenHandler
  }, /*#__PURE__*/react.createElement("h3", {
    className: (subscriptions_module_default())["subs-item-title"]
  }, item.label), /*#__PURE__*/react.createElement("div", {
    className: (subscriptions_module_default())["subs-item-content"],
    dangerouslySetInnerHTML: {
      __html: content
    }
  })));
};

SubsItem.propTypes = {
  item: (prop_types_default()).object,
  width: (prop_types_default()).number,
  index: (prop_types_default()).number
};
/* harmony default export */ var subscriptions_SubsItem = (SubsItem);
;// CONCATENATED MODULE: ./src/next/components/subscriptions/SubsContent.js
function SubsContent_slicedToArray(arr, i) { return SubsContent_arrayWithHoles(arr) || SubsContent_iterableToArrayLimit(arr, i) || SubsContent_unsupportedIterableToArray(arr, i) || SubsContent_nonIterableRest(); }

function SubsContent_nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function SubsContent_unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return SubsContent_arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return SubsContent_arrayLikeToArray(o, minLen); }

function SubsContent_arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }

function SubsContent_iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function SubsContent_arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }








var SubsContent = function SubsContent() {
  var _useTranslation = (0,esm/* useTranslation */.$G)(),
      t = _useTranslation.t;

  var _useSubscriptionsCont = (0,contexts_subscriptions/* useSubscriptionsContext */.T)(),
      fetchContent = _useSubscriptionsCont.fetchContent,
      date = _useSubscriptionsCont.date,
      content = _useSubscriptionsCont.content;

  var contentRef = (0,react.useRef)();

  var _useState = (0,react.useState)(null),
      _useState2 = SubsContent_slicedToArray(_useState, 2),
      width = _useState2[0],
      setWidth = _useState2[1];

  (0,react.useEffect)(function () {
    if (contentRef.current) {
      setWidth(contentRef.current.offsetWidth);
    }
  }, []);
  (0,react.useEffect)(function () {
    fetchContent();
  }, [fetchContent]);

  var renderItem = function renderItem(contentItem, index) {
    return /*#__PURE__*/react.createElement(subscriptions_SubsItem, {
      key: contentItem.book_id,
      width: width,
      item: contentItem,
      index: index
    });
  };

  var dateContent = content[date] || [];

  if (!dateContent.length) {
    return /*#__PURE__*/react.createElement("div", {
      ref: contentRef,
      className: (subscriptions_module_default())["subs-default-text"]
    }, t("noSubs"), /*#__PURE__*/react.createElement("br", null), t("pleaseAddSub"));
  }

  return /*#__PURE__*/react.createElement("div", {
    ref: contentRef
  }, dateContent.map(renderItem));
};

SubsContent.propTypes = {
  subsContent: (prop_types_default()).object,
  setSubsContent: (prop_types_default()).func
};
/* harmony default export */ var subscriptions_SubsContent = (SubsContent);
;// CONCATENATED MODULE: ../shared/components/feeds/FeedsSlider.js
function FeedsSlider_slicedToArray(arr, i) { return FeedsSlider_arrayWithHoles(arr) || FeedsSlider_iterableToArrayLimit(arr, i) || FeedsSlider_unsupportedIterableToArray(arr, i) || FeedsSlider_nonIterableRest(); }

function FeedsSlider_nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function FeedsSlider_unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return FeedsSlider_arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return FeedsSlider_arrayLikeToArray(o, minLen); }

function FeedsSlider_arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }

function FeedsSlider_iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function FeedsSlider_arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }





var FeedsSlider = function FeedsSlider(_ref) {
  var children = _ref.children,
      _ref$records = _ref.records,
      records = _ref$records === void 0 ? [] : _ref$records,
      renderItem = _ref.renderItem,
      slotFeedsSlider = _ref.slotFeedsSlider,
      renderWithProvider = _ref.renderWithProvider,
      containerClassName = _ref.containerClassName;

  var _useState = (0,react.useState)(0),
      _useState2 = FeedsSlider_slicedToArray(_useState, 2),
      activeIndex = _useState2[0],
      setActiveIndex = _useState2[1];

  var maxLength = Math.max(records.length - 1, 0);

  var nextPlaylist = function nextPlaylist() {
    if (activeIndex < maxLength) {
      setActiveIndex(activeIndex + 1);
    } else {
      setActiveIndex(0);
    }
  };

  var prevPlaylist = function prevPlaylist() {
    if (activeIndex < maxLength + 1 && activeIndex > 0) {
      setActiveIndex(activeIndex - 1);
    } else {
      setActiveIndex(maxLength);
    }
  };

  var renderPagination = function renderPagination() {
    if (maxLength === 0) {
      return null;
    }

    var showNextButton = activeIndex !== maxLength;
    var showPrevButton = activeIndex !== 0;
    return /*#__PURE__*/react.createElement(react.Fragment, null, showNextButton && /*#__PURE__*/react.createElement("div", {
      className: "feeds-slider-button next",
      onClick: function onClick() {
        return nextPlaylist();
      }
    }), showPrevButton && /*#__PURE__*/react.createElement("div", {
      className: "feeds-slider-button prev",
      onClick: function onClick() {
        return prevPlaylist();
      }
    }), /*#__PURE__*/react.createElement("div", {
      className: "feeds-slider-pagination"
    }, records.map(function (_, index) {
      return /*#__PURE__*/react.createElement("span", {
        onClick: function onClick() {
          return setActiveIndex(index);
        },
        key: index,
        className: classnames_default()("feeds-slider-pagination-bullet", {
          "active": index === activeIndex
        })
      });
    })));
  };

  var renderItems = function renderItems() {
    var renderedItems = records.map(function (item, index) {
      return /*#__PURE__*/react.createElement("div", {
        key: index,
        className: classnames_default()("feeds-slider-item", {
          "active": activeIndex === index
        })
      }, renderItem({
        item: item
      }));
    });

    if (renderWithProvider && typeof renderWithProvider === "function") {
      return renderWithProvider(renderedItems);
    }

    return renderedItems;
  };

  return /*#__PURE__*/react.createElement("div", {
    className: classnames_default()("feeds-slider-container", containerClassName)
  }, /*#__PURE__*/react.createElement("div", {
    className: "feeds-slider"
  }, !!records.length && /*#__PURE__*/react.createElement("div", {
    className: "feeds-slider-wrapper",
    style: {
      "transform": "translateX(-".concat(activeIndex * 100, "%)")
    }
  }, renderItems()), slotFeedsSlider), renderPagination(), children);
};

FeedsSlider.propTypes = {
  children: (prop_types_default()).node,
  slotFeedsSlider: (prop_types_default()).node,
  records: (prop_types_default()).array,
  renderItem: (prop_types_default()).func,
  renderWithProvider: (prop_types_default()).func,
  containerClassName: (prop_types_default()).string
};
/* harmony default export */ var feeds_FeedsSlider = (FeedsSlider);
;// CONCATENATED MODULE: ../shared/components/feeds/FacebookFeeds.js



var FACEBOOK_APP_ID = "815910781864360";

var FacebookFeeds = function FacebookFeeds(_ref) {
  var t = _ref.t;
  var feeds = ["ellenwhitewritings"];

  var preloadScript = function preloadScript(id) {
    if (document.getElementById(id)) {
      return;
    }

    var firstScriptElement = document.getElementsByTagName("script")[0];
    var script = document.createElement("script");
    script.id = id;
    script.src = "https://connect.facebook.net/en_EN/sdk.js#xfbml=1&version=v3.1&appId=".concat(FACEBOOK_APP_ID, "&autoLogAppEvents=1");
    firstScriptElement.parentNode.insertBefore(script, firstScriptElement);
  };

  var renderItem = function renderItem(_ref2) {
    var item = _ref2.item;
    return /*#__PURE__*/react.createElement("div", {
      className: "fb-page",
      "data-width": 9999,
      "data-href": "https://www.facebook.com/".concat(item, "/"),
      "data-tabs": "timeline",
      "data-small-header": "true",
      "data-adapt-container-width": "true",
      "data-hide-cover": "false",
      "data-show-facepile": "false"
    });
  };

  (0,react.useEffect)(function () {
    if (!window.FB) {
      preloadScript("facebook_timeline_widget");
    } else {
      window.FB.XFBML.parse();
    }
  }, []);
  return /*#__PURE__*/react.createElement(feeds_FeedsSlider, {
    renderItem: renderItem,
    records: feeds,
    containerClassName: "facebook-feeds"
  }, /*#__PURE__*/react.createElement("h3", {
    className: "feeds-header"
  }, t("follow_us_on"), /*#__PURE__*/react.createElement("a", {
    href: "https://www.facebook.com/ellenwhitewritings",
    rel: "nofollow noopener noreferrer",
    target: "_blank"
  }, t("facebook"))));
};

FacebookFeeds.propTypes = {
  t: (prop_types_default()).func.isRequired
};
/* harmony default export */ var feeds_FacebookFeeds = (FacebookFeeds);
// EXTERNAL MODULE: ../node_modules/axios/index.js
var axios = __webpack_require__(14206);
var axios_default = /*#__PURE__*/__webpack_require__.n(axios);
// EXTERNAL MODULE: ../shared/utils/appServer/appServer.js
var appServer = __webpack_require__(12537);
// EXTERNAL MODULE: ../shared/utils/url/url.js
var url = __webpack_require__(59916);
// EXTERNAL MODULE: ../shared/hooks/viewMode.js
var viewMode = __webpack_require__(6569);
;// CONCATENATED MODULE: ../shared/utils/external/instagram/constants.js
var INSTAGRAM_URL_ORIGIN = "https://www.instagram.com";
var INSTAGRAM_USERNAME = "egwwritings";
var INSTAGRAM_ACCOUNT_URL = INSTAGRAM_URL_ORIGIN + "/" + INSTAGRAM_USERNAME;
;// CONCATENATED MODULE: ../shared/components/feeds/InstagramFeeds.js
function InstagramFeeds_slicedToArray(arr, i) { return InstagramFeeds_arrayWithHoles(arr) || InstagramFeeds_iterableToArrayLimit(arr, i) || InstagramFeeds_unsupportedIterableToArray(arr, i) || InstagramFeeds_nonIterableRest(); }

function InstagramFeeds_nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function InstagramFeeds_unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return InstagramFeeds_arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return InstagramFeeds_arrayLikeToArray(o, minLen); }

function InstagramFeeds_arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }

function InstagramFeeds_iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function InstagramFeeds_arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }









var postIdFallback = "CetS-fqu0Q3";
var lastPostId;

var InstagramFeeds = function InstagramFeeds(_ref) {
  var t = _ref.t;
  var remToPx = (0,viewMode/* useRemToPx */.y)();

  var _useState = (0,react.useState)(true),
      _useState2 = InstagramFeeds_slicedToArray(_useState, 2),
      isLoading = _useState2[0],
      setIsLoading = _useState2[1];

  var _useState3 = (0,react.useState)(false),
      _useState4 = InstagramFeeds_slicedToArray(_useState3, 2),
      isError = _useState4[0],
      setIsError = _useState4[1];

  var _useState5 = (0,react.useState)(lastPostId),
      _useState6 = InstagramFeeds_slicedToArray(_useState5, 2),
      postId = _useState6[0],
      setPostId = _useState6[1];

  (0,react.useEffect)(function () {
    if (!postId) {
      axios_default().get((0,url/* getBaseHost */.UO)() + appServer/* APIUrls.getInstagramLastPostId */.Go.getInstagramLastPostId).then(function (response) {
        if (response.data.data) {
          setPostId(response.data.data);
        } else {
          setPostId(postIdFallback);
        }
      }).catch(function () {
        setPostId(postIdFallback);
      }).finally(function () {
        setIsLoading(false);
      });
    }
  }, [postId]);

  if (isError && !isLoading) {
    return /*#__PURE__*/react.createElement("div", {
      className: "feeds-instagram-no-data"
    }, /*#__PURE__*/react.createElement("span", null, "No data"), /*#__PURE__*/react.createElement("h3", {
      className: "feeds-header"
    }, t("follow_us_on"), /*#__PURE__*/react.createElement("a", {
      href: INSTAGRAM_ACCOUNT_URL,
      rel: "nofollow noopener noreferrer",
      target: "_blank"
    }, t("instagram"))));
  }

  return /*#__PURE__*/react.createElement(feeds_FeedsSlider, {
    slotFeedsSlider: /*#__PURE__*/react.createElement(react.Fragment, null, isLoading && /*#__PURE__*/react.createElement("div", {
      className: "feeds-instagram-no-data"
    }, t("loading"), "\u2026"), postId && /*#__PURE__*/react.createElement("iframe", {
      onLoad: function onLoad() {
        setIsLoading(false);
      },
      onError: function onError() {
        setIsError(true);
      },
      width: remToPx(16),
      height: remToPx(18.7),
      src: INSTAGRAM_URL_ORIGIN + "/p/" + postId + "/embed",
      frameBorder: "0"
    }))
  });
};

InstagramFeeds.propTypes = {
  t: (prop_types_default()).func.isRequired
};
/* harmony default export */ var feeds_InstagramFeeds = (InstagramFeeds);
;// CONCATENATED MODULE: ../shared/components/feeds/PinterestFeeds.js




var PinterestFeeds = function PinterestFeeds(_ref) {
  var t = _ref.t;
  var feeds = ["egwwritings"];

  var preloadScript = function preloadScript() {
    var script = document.createElement("script");
    script.async = true;
    script.dataset.pinBuild = "doBuild";
    script.src = "//assets.pinterest.com/js/pinit.js";
    document.body.appendChild(script);
  };

  var renderItem = function renderItem(_ref2) {
    var item = _ref2.item;
    return /*#__PURE__*/react.createElement("a", {
      "data-pin-do": "embedUser",
      "data-pin-scale-width": "80",
      href: "https://www.pinterest.com/".concat(item, "/")
    });
  };

  (0,react.useEffect)(function () {
    if (!window.doBuild) {
      preloadScript();
    } else {
      window.doBuild();
    }
  }, []);
  return /*#__PURE__*/react.createElement(feeds_FeedsSlider, {
    renderItem: renderItem,
    records: feeds,
    containerClassName: "pinterest-feeds"
  }, /*#__PURE__*/react.createElement("h3", {
    className: "feeds-header"
  }, t("follow_us_on"), /*#__PURE__*/react.createElement("a", {
    href: "https://www.pinterest.com/egwwritings/",
    rel: "nofollow noopener noreferrer",
    target: "_blank"
  }, t("pinterest"))));
};

PinterestFeeds.propTypes = {
  t: (prop_types_default()).func.isRequired
};
/* harmony default export */ var feeds_PinterestFeeds = (PinterestFeeds);
;// CONCATENATED MODULE: ../node_modules/react-twitter-embed/dist/index.modern.js


var twitterWidgetJs = 'https://platform.twitter.com/widgets.js';

var methodName = 'createTimeline';

var TwitterTimelineEmbed = function TwitterTimelineEmbed(props) {
  var ref = react.useRef(null);

  var _React$useState = react.useState(true),
      loading = _React$useState[0],
      setLoading = _React$useState[1];

  var buildOptions = function buildOptions() {
    var options = Object.assign({}, props.options);

    if (props !== null && props !== void 0 && props.autoHeight) {
      var _ref$current, _ref$current$parentNo;

      options.height = (_ref$current = ref.current) === null || _ref$current === void 0 ? void 0 : (_ref$current$parentNo = _ref$current.parentNode) === null || _ref$current$parentNo === void 0 ? void 0 : _ref$current$parentNo.offsetHeight;
    }

    options = Object.assign({}, options, {
      theme: props === null || props === void 0 ? void 0 : props.theme,
      linkColor: props === null || props === void 0 ? void 0 : props.linkColor,
      borderColor: props === null || props === void 0 ? void 0 : props.borderColor,
      lang: props === null || props === void 0 ? void 0 : props.lang,
      tweetLimit: props === null || props === void 0 ? void 0 : props.tweetLimit,
      ariaPolite: props === null || props === void 0 ? void 0 : props.ariaPolite
    });
    return options;
  };

  var buildChromeOptions = function buildChromeOptions(options) {
    options.chrome = '';

    if (props.noHeader) {
      options.chrome = options.chrome + ' noheader';
    }

    if (props.noFooter) {
      options.chrome = options.chrome + ' nofooter';
    }

    if (props.noBorders) {
      options.chrome = options.chrome + ' noborders';
    }

    if (props.noScrollbar) {
      options.chrome = options.chrome + ' noscrollbar';
    }

    if (props.transparent) {
      options.chrome = options.chrome + ' transparent';
    }

    return options;
  };

  react.useEffect(function () {
    var isComponentMounted = true;

    var script = __webpack_require__(18801);

    script(twitterWidgetJs, 'twitter-embed', function () {
      if (!window.twttr) {
        console.error('Failure to load window.twttr, aborting load');
        return;
      }

      if (isComponentMounted) {
        if (!window.twttr.widgets[methodName]) {
          console.error("Method " + methodName + " is not present anymore in twttr.widget api");
          return;
        }

        var options = buildOptions();
        options = buildChromeOptions(options);
        window.twttr.widgets[methodName]({
          sourceType: props.sourceType,
          screenName: props.screenName,
          userId: props.userId,
          ownerScreenName: props.ownerScreenName,
          slug: props.slug,
          id: props.id || props.widgetId,
          url: props.url
        }, ref === null || ref === void 0 ? void 0 : ref.current, options).then(function (element) {
          setLoading(false);

          if (props.onLoad) {
            props.onLoad(element);
          }
        });
      }
    });
    return function () {
      isComponentMounted = false;
    };
  }, []);
  return react.createElement(react.Fragment, null, loading && react.createElement(react.Fragment, null, props.placeholder), react.createElement("div", {
    ref: ref
  }));
};

var methodName$1 = 'createShareButton';

var TwitterShareButton = function TwitterShareButton(props) {
  var ref = React.useRef(null);

  var _React$useState = React.useState(true),
      loading = _React$useState[0],
      setLoading = _React$useState[1];

  React.useEffect(function () {
    var isComponentMounted = true;

    var script = __webpack_require__(18801);

    script(twitterWidgetJs, 'twitter-embed', function () {
      if (!window.twttr) {
        console.error('Failure to load window.twttr, aborting load');
        return;
      }

      if (isComponentMounted) {
        if (!window.twttr.widgets[methodName$1]) {
          console.error("Method " + methodName$1 + " is not present anymore in twttr.widget api");
          return;
        }

        window.twttr.widgets[methodName$1](props.url, ref === null || ref === void 0 ? void 0 : ref.current, props.options).then(function (element) {
          setLoading(false);

          if (props.onLoad) {
            props.onLoad(element);
          }
        });
      }
    });
    return function () {
      isComponentMounted = false;
    };
  }, []);
  return React.createElement(React.Fragment, null, loading && React.createElement(React.Fragment, null, props.placeholder), React.createElement("div", {
    ref: ref
  }));
};

var methodName$2 = 'createFollowButton';

var TwitterFollowButton = function TwitterFollowButton(props) {
  var ref = React.useRef(null);

  var _React$useState = React.useState(true),
      loading = _React$useState[0],
      setLoading = _React$useState[1];

  React.useEffect(function () {
    var isComponentMounted = true;

    var script = __webpack_require__(18801);

    script(twitterWidgetJs, 'twitter-embed', function () {
      if (!window.twttr) {
        console.error('Failure to load window.twttr, aborting load');
        return;
      }

      if (isComponentMounted) {
        if (!window.twttr.widgets[methodName$2]) {
          console.error("Method " + methodName$2 + " is not present anymore in twttr.widget api");
          return;
        }

        window.twttr.widgets[methodName$2](props.screenName, ref === null || ref === void 0 ? void 0 : ref.current, props.options).then(function (element) {
          setLoading(false);

          if (props.onLoad) {
            props.onLoad(element);
          }
        });
      }
    });
    return function () {
      isComponentMounted = false;
    };
  }, []);
  return React.createElement(React.Fragment, null, loading && React.createElement(React.Fragment, null, props.placeholder), React.createElement("div", {
    ref: ref
  }));
};

var methodName$3 = 'createHashtagButton';

var TwitterHashtagButton = function TwitterHashtagButton(props) {
  var ref = React.useRef(null);

  var _React$useState = React.useState(true),
      loading = _React$useState[0],
      setLoading = _React$useState[1];

  React.useEffect(function () {
    var isComponentMounted = true;

    var script = __webpack_require__(18801);

    script(twitterWidgetJs, 'twitter-embed', function () {
      if (!window.twttr) {
        console.error('Failure to load window.twttr, aborting load');
        return;
      }

      if (isComponentMounted) {
        if (!window.twttr.widgets[methodName$3]) {
          console.error("Method " + methodName$3 + " is not present anymore in twttr.widget api");
          return;
        }

        window.twttr.widgets[methodName$3](props.tag, ref === null || ref === void 0 ? void 0 : ref.current, props.options).then(function (element) {
          setLoading(false);

          if (props.onLoad) {
            props.onLoad(element);
          }
        });
      }
    });
    return function () {
      isComponentMounted = false;
    };
  }, []);
  return React.createElement(React.Fragment, null, loading && React.createElement(React.Fragment, null, props.placeholder), React.createElement("div", {
    ref: ref
  }));
};

var methodName$4 = 'createMentionButton';

var TwitterMentionButton = function TwitterMentionButton(props) {
  var ref = React.useRef(null);

  var _React$useState = React.useState(true),
      loading = _React$useState[0],
      setLoading = _React$useState[1];

  React.useEffect(function () {
    var isComponentMounted = true;

    var script = __webpack_require__(18801);

    script(twitterWidgetJs, 'twitter-embed', function () {
      if (!window.twttr) {
        console.error('Failure to load window.twttr, aborting load');
        return;
      }

      if (isComponentMounted) {
        if (!window.twttr.widgets[methodName$4]) {
          console.error("Method " + methodName$4 + " is not present anymore in twttr.widget api");
          return;
        }

        window.twttr.widgets[methodName$4](props.screenName, ref === null || ref === void 0 ? void 0 : ref.current, props.options).then(function (element) {
          setLoading(false);

          if (props.onLoad) {
            props.onLoad(element);
          }
        });
      }
    });
    return function () {
      isComponentMounted = false;
    };
  }, []);
  return React.createElement(React.Fragment, null, loading && React.createElement(React.Fragment, null, props.placeholder), React.createElement("div", {
    ref: ref
  }));
};

var methodName$5 = 'createTweet';

var TwitterTweetEmbed = function TwitterTweetEmbed(props) {
  var ref = React.useRef(null);

  var _React$useState = React.useState(true),
      loading = _React$useState[0],
      setLoading = _React$useState[1];

  React.useEffect(function () {
    var isComponentMounted = true;

    var script = __webpack_require__(18801);

    script(twitterWidgetJs, 'twitter-embed', function () {
      if (!window.twttr) {
        console.error('Failure to load window.twttr, aborting load');
        return;
      }

      if (isComponentMounted) {
        if (!window.twttr.widgets[methodName$5]) {
          console.error("Method " + methodName$5 + " is not present anymore in twttr.widget api");
          return;
        }

        window.twttr.widgets[methodName$5](props.tweetId, ref === null || ref === void 0 ? void 0 : ref.current, props.options).then(function (element) {
          setLoading(false);

          if (props.onLoad) {
            props.onLoad(element);
          }
        });
      }
    });
    return function () {
      isComponentMounted = false;
    };
  }, []);
  return React.createElement(React.Fragment, null, loading && React.createElement(React.Fragment, null, props.placeholder), React.createElement("div", {
    ref: ref
  }));
};

var methodName$6 = 'createMoment';

var TwitterMomentShare = function TwitterMomentShare(props) {
  var ref = React.useRef(null);

  var _React$useState = React.useState(true),
      loading = _React$useState[0],
      setLoading = _React$useState[1];

  React.useEffect(function () {
    var isComponentMounted = true;

    var script = __webpack_require__(18801);

    script(twitterWidgetJs, 'twitter-embed', function () {
      if (!window.twttr) {
        console.error('Failure to load window.twttr, aborting load');
        return;
      }

      if (isComponentMounted) {
        if (!window.twttr.widgets[methodName$6]) {
          console.error("Method " + methodName$6 + " is not present anymore in twttr.widget api");
          return;
        }

        window.twttr.widgets[methodName$6](props.momentId, ref === null || ref === void 0 ? void 0 : ref.current, props.options).then(function (element) {
          setLoading(false);

          if (props.onLoad) {
            props.onLoad(element);
          }
        });
      }
    });
    return function () {
      isComponentMounted = false;
    };
  }, []);
  return React.createElement(React.Fragment, null, loading && React.createElement(React.Fragment, null, props.placeholder), React.createElement("div", {
    ref: ref
  }));
};

var methodName$7 = 'createDMButton';

var TwitterDMButton = function TwitterDMButton(props) {
  var ref = React.useRef(null);

  var _React$useState = React.useState(true),
      loading = _React$useState[0],
      setLoading = _React$useState[1];

  React.useEffect(function () {
    var isComponentMounted = true;

    var script = __webpack_require__(18801);

    script(twitterWidgetJs, 'twitter-embed', function () {
      if (!window.twttr) {
        console.error('Failure to load window.twttr, aborting load');
        return;
      }

      if (isComponentMounted) {
        if (!window.twttr.widgets[methodName$7]) {
          console.error("Method " + methodName$7 + " is not present anymore in twttr.widget api");
          return;
        }

        window.twttr.widgets[methodName$7](props.id, ref === null || ref === void 0 ? void 0 : ref.current, props.options).then(function (element) {
          if (isComponentMounted) {
            setLoading(false);

            if (props.onLoad) {
              props.onLoad(element);
            }
          }
        });
      }
    });
    return function () {
      isComponentMounted = false;
    };
  }, []);
  return React.createElement(React.Fragment, null, loading && React.createElement(React.Fragment, null, props.placeholder), React.createElement("div", {
    ref: ref
  }));
};

var methodName$8 = 'createVideo';

var TwitterVideoEmbed = function TwitterVideoEmbed(props) {
  var ref = React.useRef(null);

  var _React$useState = React.useState(true),
      loading = _React$useState[0],
      setLoading = _React$useState[1];

  React.useEffect(function () {
    var isComponentMounted = true;

    var script = __webpack_require__(18801);

    script(twitterWidgetJs, 'twitter-embed', function () {
      if (!window.twttr) {
        console.error('Failure to load window.twttr, aborting load');
        return;
      }

      if (isComponentMounted) {
        if (!window.twttr.widgets[methodName$8]) {
          console.error("Method " + methodName$8 + " is not present anymore in twttr.widget api");
          return;
        }

        window.twttr.widgets[methodName$8](props.id, ref === null || ref === void 0 ? void 0 : ref.current).then(function (element) {
          setLoading(false);

          if (props.onLoad) {
            props.onLoad(element);
          }
        });
      }
    });
    return function () {
      isComponentMounted = false;
    };
  }, []);
  return React.createElement(React.Fragment, null, loading && React.createElement(React.Fragment, null, props.placeholder), React.createElement("div", {
    ref: ref
  }));
};

var methodName$9 = 'createPeriscopeOnAirButton';

var TwitterOnAirButton = function TwitterOnAirButton(props) {
  var ref = React.useRef(null);

  var _React$useState = React.useState(true),
      loading = _React$useState[0],
      setLoading = _React$useState[1];

  React.useEffect(function () {
    var isComponentMounted = true;

    var script = __webpack_require__(18801);

    script(twitterWidgetJs, 'twitter-embed', function () {
      if (!window.twttr) {
        console.error('Failure to load window.twttr, aborting load');
        return;
      }

      if (isComponentMounted) {
        if (!window.twttr.widgets[methodName$9]) {
          console.error("Method " + methodName$9 + " is not present anymore in twttr.widget api");
          return;
        }

        window.twttr.widgets[methodName$9](props.username, ref === null || ref === void 0 ? void 0 : ref.current, props.options).then(function (element) {
          setLoading(false);

          if (props.onLoad) {
            props.onLoad(element);
          }
        });
      }
    });
    return function () {
      isComponentMounted = false;
    };
  }, []);
  return React.createElement(React.Fragment, null, loading && React.createElement(React.Fragment, null, props.placeholder), React.createElement("div", {
    ref: ref
  }));
};


//# sourceMappingURL=index.modern.js.map

;// CONCATENATED MODULE: ../shared/components/feeds/TwitterFeeds.js





var TwitterFeeds = function TwitterFeeds(_ref) {
  var t = _ref.t;
  var feeds = ["EGWwritings", "ellenwhite"];

  var renderItem = function renderItem(_ref2) {
    var item = _ref2.item;
    return /*#__PURE__*/react.createElement(TwitterTimelineEmbed, {
      sourceType: "profile",
      screenName: item
    });
  };

  return /*#__PURE__*/react.createElement(feeds_FeedsSlider, {
    renderItem: renderItem,
    records: feeds,
    containerClassName: "twitter-feeds"
  }, /*#__PURE__*/react.createElement("h3", {
    className: "feeds-header"
  }, t("follow_us_on"), /*#__PURE__*/react.createElement("a", {
    href: "https://twitter.com/egwwritings?lang=en",
    rel: "nofollow noopener noreferrer",
    target: "_blank"
  }, "X (Twitter)")));
};

TwitterFeeds.propTypes = {
  t: (prop_types_default()).func.isRequired
};
/* harmony default export */ var feeds_TwitterFeeds = (TwitterFeeds);
// EXTERNAL MODULE: ../shared/utils/external/youtube/constants.js
var constants = __webpack_require__(10620);
;// CONCATENATED MODULE: ../shared/components/feeds/YoutubeFeeds.js
function YoutubeFeeds_slicedToArray(arr, i) { return YoutubeFeeds_arrayWithHoles(arr) || YoutubeFeeds_iterableToArrayLimit(arr, i) || YoutubeFeeds_unsupportedIterableToArray(arr, i) || YoutubeFeeds_nonIterableRest(); }

function YoutubeFeeds_nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function YoutubeFeeds_unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return YoutubeFeeds_arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return YoutubeFeeds_arrayLikeToArray(o, minLen); }

function YoutubeFeeds_arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }

function YoutubeFeeds_iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function YoutubeFeeds_arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }






var YoutubeFeeds = function YoutubeFeeds(_ref) {
  var t = _ref.t;

  var _useState = (0,react.useState)([]),
      _useState2 = YoutubeFeeds_slicedToArray(_useState, 2),
      players = _useState2[0],
      setPlayers = _useState2[1];

  var feeds = [{
    playerId: "embeddedvideoiframe1",
    listId: "PLqGlkhsuXZVeSJUwaLeGKs5V31DqogQD-"
  }, {
    playerId: "embeddedvideoiframe2",
    listId: "PLqGlkhsuXZVf29YDczMEAWcuBZDg3WO-f"
  }];

  var preloadScript = function preloadScript(id) {
    if (document.getElementById(id)) {
      return;
    }

    var script = document.createElement("script");
    script.id = id;
    script.src = "//www.youtube.com/iframe_api";
    var firstScriptElement = document.getElementsByTagName("script")[0];
    firstScriptElement.parentNode.insertBefore(script, firstScriptElement);
  };

  var renderItem = function renderItem(_ref2) {
    var item = _ref2.item;
    var playerId = item.playerId,
        listId = item.listId;
    return /*#__PURE__*/react.createElement("iframe", {
      id: playerId,
      src: "https://www.youtube.com/embed/videoseries?enablejsapi=1&list=".concat(listId),
      frameBorder: "0",
      allow: "accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture",
      allowFullScreen: "allowfullscreen"
    });
  };

  var onYouTubeIframeAPIReady = function onYouTubeIframeAPIReady() {
    var _window = window,
        YT = _window.YT;

    if (YT && YT.loaded) {
      var playersArray = [];
      feeds.forEach(function (_ref3) {
        var playerId = _ref3.playerId,
            listId = _ref3.listId;
        playersArray.push(new YT.Player(playerId, {
          height: "100%",
          width: "100%",
          videoId: listId,
          events: {
            "onStateChange": function onStateChange(event) {
              if (event.data === YT.PlayerState.PLAYING) {
                playersArray.forEach(function (player) {
                  if (player.getPlayerState() === window.YT.PlayerState.PLAYING && player.getIframe().id !== event.target.getIframe().id) {
                    player.pauseVideo();
                  }
                });
              }
            }
          }
        }));
      });
      setPlayers(playersArray);
    }
  };

  (0,react.useEffect)(function () {
    preloadScript("youtube_iframe_api");
    window.onYouTubeIframeAPIReady = onYouTubeIframeAPIReady;

    if (window.YT) {
      onYouTubeIframeAPIReady();
    }
  }, []);
  (0,react.useEffect)(function () {
    var destroyPlayers = function destroyPlayers(players) {
      if (players.length > 0) {
        players.forEach(function (player) {
          player.destroy();
        });
      }
    };

    return function () {
      destroyPlayers(players);
    };
  }, [players]);
  return /*#__PURE__*/react.createElement(feeds_FeedsSlider, {
    renderItem: renderItem,
    records: feeds,
    containerClassName: "youtube-feeds"
  }, /*#__PURE__*/react.createElement("h3", {
    className: "feeds-header"
  }, t("follow_us_on"), /*#__PURE__*/react.createElement("a", {
    href: constants/* YOUTUBE_CHANNEL_URL */.OV,
    rel: "nofollow noopener noreferrer",
    target: "_blank"
  }, t("youtube"))));
};

YoutubeFeeds.propTypes = {
  t: (prop_types_default()).func.isRequired
};
/* harmony default export */ var feeds_YoutubeFeeds = (YoutubeFeeds);
;// CONCATENATED MODULE: ../shared/components/feeds/index.js





;// CONCATENATED MODULE: ./src/next/components/subscriptions/Feeds.js




var Feeds = function Feeds() {
  var _useTranslation = (0,esm/* useTranslation */.$G)(),
      t = _useTranslation.t;

  return /*#__PURE__*/react.createElement("div", {
    className: "feeds-container-wrapper"
  }, /*#__PURE__*/react.createElement(feeds_TwitterFeeds, {
    t: t
  }), /*#__PURE__*/react.createElement(feeds_InstagramFeeds, {
    t: t
  }), /*#__PURE__*/react.createElement(feeds_FacebookFeeds, {
    t: t
  }), /*#__PURE__*/react.createElement(feeds_PinterestFeeds, {
    t: t
  }), /*#__PURE__*/react.createElement(feeds_YoutubeFeeds, {
    t: t
  }));
};

/* harmony default export */ var subscriptions_Feeds = (Feeds);
// EXTERNAL MODULE: ../shared/utils/content/content.js
var content = __webpack_require__(69051);
;// CONCATENATED MODULE: ./src/next/components/subscriptions/Thoughts.js










var Thoughts = function Thoughts() {
  var _useTranslation = (0,esm/* useTranslation */.$G)(),
      t = _useTranslation.t;

  var _useSubscriptionsCont = (0,contexts_subscriptions/* useSubscriptionsContext */.T)(),
      fetchThoughts = _useSubscriptionsCont.fetchThoughts,
      date = _useSubscriptionsCont.date,
      thoughts = _useSubscriptionsCont.thoughts;

  (0,react.useEffect)(function () {
    fetchThoughts();
  }, [fetchThoughts]);
  var dateThoughts = thoughts[date] || [];

  if (!dateThoughts.length) {
    return /*#__PURE__*/react.createElement("div", {
      className: (subscriptions_module_default())["subs-default-text"]
    }, t("noThoughts"));
  }

  return dateThoughts.map(function (item, index) {
    return /*#__PURE__*/react.createElement("div", {
      key: index,
      className: (subscriptions_module_default())["subs-thought-item"]
    }, /*#__PURE__*/react.createElement("div", {
      className: (subscriptions_module_default())["subs-thought-item-content"],
      dangerouslySetInnerHTML: {
        __html: item.content
      }
    }), /*#__PURE__*/react.createElement("div", {
      className: (subscriptions_module_default())["subs-thought-item-title"]
    }, /*#__PURE__*/react.createElement("div", {
      className: (subscriptions_module_default())["subs-thought-item-title-text"]
    }, item.title), /*#__PURE__*/react.createElement(components/* SharePopup */.po, {
      url: "",
      title: item.title,
      text: (0,content/* removeTags */.av)(item.content),
      renderButton: function renderButton(_ref) {
        var show = _ref.show,
            onClick = _ref.onClick;
        return /*#__PURE__*/react.createElement(IconView/* default */.Z, {
          icon: CommonIcons/* ShareIcon */.aA,
          className: (subscriptions_module_default())["subs-share-icon"] + (show ? " active" : ""),
          onClick: onClick
        });
      }
    })));
  });
};

Thoughts.propTypes = {
  thoughts: (prop_types_default()).object,
  setThoughts: (prop_types_default()).func
};
/* harmony default export */ var subscriptions_Thoughts = (Thoughts);
// EXTERNAL MODULE: ./src/next/components/subscriptions/SubscriptionsDatePicker.js + 2 modules
var SubscriptionsDatePicker = __webpack_require__(63086);
// EXTERNAL MODULE: ../shared/components/DateSwitcher/dateSwitcher/DateSwitcher.js
var DateSwitcher = __webpack_require__(67442);
// EXTERNAL MODULE: ../shared/utils/date/index.js
var utils_date = __webpack_require__(96112);
;// CONCATENATED MODULE: ./src/next/components/subscriptions/SubsTopPanel.js













var SubsTopPanel = function SubsTopPanel(_ref) {
  var onDateChange = _ref.onDateChange;

  var _useTranslation = (0,esm/* useTranslation */.$G)(),
      t = _useTranslation.t;

  var _useSubscriptionsCont = (0,contexts_subscriptions/* useSubscriptionsContext */.T)(),
      subscriptions = _useSubscriptionsCont.subscriptions,
      date = _useSubscriptionsCont.date;

  return /*#__PURE__*/react.createElement("div", {
    className: (subscriptions_module_default())["subs-top-panel"]
  }, /*#__PURE__*/react.createElement(DateSwitcher/* default */.Z, {
    SubscriptionsDatePicker: SubscriptionsDatePicker/* SubscriptionsDatePicker */.O,
    date: (0,utils_date/* formatServerDateToJSDate */.IS)(date),
    onDateChange: onDateChange
  }), /*#__PURE__*/react.createElement("div", {
    className: (subscriptions_module_default())["subs-top-panel-actions"]
  }, /*#__PURE__*/react.createElement(Button/* default */.Z, {
    rootTagName: "a",
    href: (0,url/* getSubsAddUrl */.Dt)(),
    target: "_blank",
    title: t("subscriptions_add"),
    className: (subscriptions_module_default())["subs-top-panel-action"]
  }, /*#__PURE__*/react.createElement(IconView/* default */.Z, {
    icon: EgwWebFont/* default.add-subscription */.Z["add-subscription"]
  })), /*#__PURE__*/react.createElement(Button/* default */.Z, {
    rootTagName: "a",
    href: (0,url/* getSubsEditUrl */.iQ)(),
    target: "_blank",
    title: t("subscriptions_edit"),
    className: (subscriptions_module_default())["subs-top-panel-action"],
    disabled: !(subscriptions !== null && subscriptions !== void 0 && subscriptions.length)
  }, /*#__PURE__*/react.createElement(IconView/* default */.Z, {
    icon: EgwWebFont/* default.edit */.Z.edit
  }))));
};

SubsTopPanel.propTypes = {
  onDateChange: (prop_types_default()).func
};
/* harmony default export */ var subscriptions_SubsTopPanel = (SubsTopPanel);
// EXTERNAL MODULE: ./src/next/hocs/withLogin.js + 1 modules
var withLogin = __webpack_require__(37482);
// EXTERNAL MODULE: ../shared/utils/select.js
var utils_select = __webpack_require__(48018);
;// CONCATENATED MODULE: ./src/next/components/subscriptions/Subscriptions.js
function Subscriptions_slicedToArray(arr, i) { return Subscriptions_arrayWithHoles(arr) || Subscriptions_iterableToArrayLimit(arr, i) || Subscriptions_unsupportedIterableToArray(arr, i) || Subscriptions_nonIterableRest(); }

function Subscriptions_nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function Subscriptions_unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return Subscriptions_arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return Subscriptions_arrayLikeToArray(o, minLen); }

function Subscriptions_arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }

function Subscriptions_iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function Subscriptions_arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }













var KeyOptionTabSubscriptions = "subscriptions";
var tabs = [(0,utils_select/* makeOption */.D)("feeds", "feeds", {
  className: (subscriptions_module_default())["subs-tabs-title"]
}), (0,utils_select/* makeOption */.D)(KeyOptionTabSubscriptions, "subscriptions", {
  className: (subscriptions_module_default())["subs-tabs-title"]
}), (0,utils_select/* makeOption */.D)("thoughts", "thoughts", {
  className: (subscriptions_module_default())["subs-tabs-title"]
})];

var Subscriptions = function Subscriptions() {
  var router = (0,next_router.useRouter)();

  var _router$query$subscri = Subscriptions_slicedToArray(router.query.subscription, 1),
      _router$query$subscri2 = _router$query$subscri[0],
      tab = _router$query$subscri2 === void 0 ? KeyOptionTabSubscriptions : _router$query$subscri2;

  var onChangeTab = function onChangeTab(key) {
    router.push("".concat(url/* URLS.subscription */.ns.subscription, "/").concat(key));
  };

  var onDateChange = function onDateChange(newDate) {
    router.push("".concat(url/* URLS.subscription */.ns.subscription, "/").concat(tab, "/").concat((0,subscriptions/* validateDate */.qS)(newDate)));
  };

  return /*#__PURE__*/react.createElement(react.Fragment, null, /*#__PURE__*/react.createElement(subscriptions_SubsTopPanel, {
    onDateChange: onDateChange
  }), /*#__PURE__*/react.createElement(Tabs/* default */.Z, {
    className: (subscriptions_module_default())["subs-tabs"],
    activeTabClassName: (subscriptions_module_default())["active-sub"],
    tabs: tabs,
    value: tab,
    onChangeTab: onChangeTab
  }, /*#__PURE__*/react.createElement(subscriptions_Feeds, null), /*#__PURE__*/react.createElement(subscriptions_SubsContent, null), /*#__PURE__*/react.createElement(subscriptions_Thoughts, null)));
};

/* harmony default export */ var subscriptions_Subscriptions = ((0,withLogin/* withLogin */.U)(Subscriptions));
;// CONCATENATED MODULE: ./src/pages/subscription/[[...subscription]].js




var SubscriptionPage = function SubscriptionPage(_ref) {
  var breadcrumbsProps = _ref.breadcrumbsProps,
      isSubscription = _ref.isSubscription,
      pageUrl = _ref.pageUrl;
  return /*#__PURE__*/react.createElement(components/* MainLayout */.Zn, {
    breadcrumbs: breadcrumbsProps
  }, /*#__PURE__*/react.createElement(components/* Head */.Fb, {
    pageTitle: breadcrumbsProps.title,
    url: pageUrl
  }), isSubscription ? /*#__PURE__*/react.createElement(subscriptions_Subscriptions, null) : /*#__PURE__*/react.createElement(components/* SubscriptionsRead */.o2, null));
};

var __N_SSP = true;
/* harmony default export */ var _subscription_ = (SubscriptionPage);

/***/ }),

/***/ 63905:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/subscription/[[...subscription]]",
      function () {
        return __webpack_require__(5522);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 90042:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"tablet":"768","desktop":"1024","md":"768","lg":"1024","base-tabs__btns-list":"Tabs_base-tabs__btns-list__SM9h2","base-tabs__tab":"Tabs_base-tabs__tab__Xm9I_","active":"Tabs_active__lcNRD","mode-blind":"Tabs_mode-blind__9qvQl"};

/***/ }),

/***/ 18801:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
  * $script.js JS loader & dependency manager
  * https://github.com/ded/script.js
  * (c) Dustin Diaz 2014 | License MIT
  */

(function (name, definition) {
  if ( true && module.exports) module.exports = definition()
  else if (true) !(__WEBPACK_AMD_DEFINE_FACTORY__ = (definition),
		__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
		(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
		__WEBPACK_AMD_DEFINE_FACTORY__),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))
  else {}
})('$script', function () {
  var doc = document
    , head = doc.getElementsByTagName('head')[0]
    , s = 'string'
    , f = false
    , push = 'push'
    , readyState = 'readyState'
    , onreadystatechange = 'onreadystatechange'
    , list = {}
    , ids = {}
    , delay = {}
    , scripts = {}
    , scriptpath
    , urlArgs

  function every(ar, fn) {
    for (var i = 0, j = ar.length; i < j; ++i) if (!fn(ar[i])) return f
    return 1
  }
  function each(ar, fn) {
    every(ar, function (el) {
      fn(el)
      return 1
    })
  }

  function $script(paths, idOrDone, optDone) {
    paths = paths[push] ? paths : [paths]
    var idOrDoneIsDone = idOrDone && idOrDone.call
      , done = idOrDoneIsDone ? idOrDone : optDone
      , id = idOrDoneIsDone ? paths.join('') : idOrDone
      , queue = paths.length
    function loopFn(item) {
      return item.call ? item() : list[item]
    }
    function callback() {
      if (!--queue) {
        list[id] = 1
        done && done()
        for (var dset in delay) {
          every(dset.split('|'), loopFn) && !each(delay[dset], loopFn) && (delay[dset] = [])
        }
      }
    }
    setTimeout(function () {
      each(paths, function loading(path, force) {
        if (path === null) return callback()
        
        if (!force && !/^https?:\/\//.test(path) && scriptpath) {
          path = (path.indexOf('.js') === -1) ? scriptpath + path + '.js' : scriptpath + path;
        }
        
        if (scripts[path]) {
          if (id) ids[id] = 1
          return (scripts[path] == 2) ? callback() : setTimeout(function () { loading(path, true) }, 0)
        }

        scripts[path] = 1
        if (id) ids[id] = 1
        create(path, callback)
      })
    }, 0)
    return $script
  }

  function create(path, fn) {
    var el = doc.createElement('script'), loaded
    el.onload = el.onerror = el[onreadystatechange] = function () {
      if ((el[readyState] && !(/^c|loade/.test(el[readyState]))) || loaded) return;
      el.onload = el[onreadystatechange] = null
      loaded = 1
      scripts[path] = 2
      fn()
    }
    el.async = 1
    el.src = urlArgs ? path + (path.indexOf('?') === -1 ? '?' : '&') + urlArgs : path;
    head.insertBefore(el, head.lastChild)
  }

  $script.get = create

  $script.order = function (scripts, id, done) {
    (function callback(s) {
      s = scripts.shift()
      !scripts.length ? $script(s, id, done) : $script(s, callback)
    }())
  }

  $script.path = function (p) {
    scriptpath = p
  }
  $script.urlArgs = function (str) {
    urlArgs = str;
  }
  $script.ready = function (deps, ready, req) {
    deps = deps[push] ? deps : [deps]
    var missing = [];
    !each(deps, function (dep) {
      list[dep] || missing[push](dep);
    }) && every(deps, function (dep) {return list[dep]}) ?
      ready() : !function (key) {
      delay[key] = delay[key] || []
      delay[key][push](ready)
      req && req(missing)
    }(deps.join('|'))
    return $script
  }

  $script.done = function (idOrDone) {
    $script([null], idOrDone)
  }

  return $script
});


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [218,239,888,774,179], function() { return __webpack_exec__(63905); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);